import PageHeadline from '../../../components/molecules/headlines/PageHeadline'
import AccountIconWh104 from '../../../components/atoms/account_icons/AccountIconWh104'
export default {
  components: {
    PageHeadline,
    AccountIconWh104
  },
  data() {
    return {
      nickname: '',
      screenName: '',
      descriptionContent: '',
      isFocusNickname: false,
      isFocusScreenName: false,
      isFocusDescription: false,
      isBirthdayDisplayable: false,
      hasErrors: false,
      uploadedImage: '',
      isUploaded: false,
      fileErrorMessage: ''
    }
  },
  mounted() {
    const errorMessage = document.querySelector('.error_message')
    if (errorMessage) {
      this.hasErrors = true
      this.enterError()
    }

    const birthdayDisplayable = document.querySelector('#birthday_displayable')
      .value

    if (birthdayDisplayable === 'true') {
      this.isBirthdayDisplayable = true
    }

    const nicknameHtml = document.querySelector('#profile_edit_form_nickname')
      .outerHTML
    const nickname = nicknameHtml.match(/value="(.*?)"/)
    if (nickname) {
      this.nickname = nickname[1]
      this.isFocusNickname = true
    }

    const screenNameHtml = document.querySelector(
      '#profile_edit_form_screen_name'
    ).outerHTML
    const screenName = screenNameHtml.match(/value="(.*?)"/)
    if (screenName) {
      this.screenName = screenName[1]
      this.isFocusScreenName = true
    }

    const descriptionContentHtml = document
      .querySelector('#profile_edit_form_description_content')
      .outerHTML.replace(/\r?\n/g, ',')
    const description = descriptionContentHtml.match(/>(.*?)<\/textarea>/)
    if (description[1] !== '') {
      this.descriptionContent = description[1].split(',').join('\n')
      this.isFocusDescription = true
    }
  },
  computed: {
    isNotEmptyNickname() {
      return this.nickname.length !== 0
    },
    isNotEmptyScreenName() {
      return this.screenName.length !== 0
    },
    isNicknameActive() {
      return this.isNotEmptyNickname || this.isFocusNickname
    },
    isScreenNameActive() {
      return this.isNotEmptyScreenName || this.isFocusScreenName
    },
    isDescriptionActive() {
      return this.descriptionContent.length !== 0 || this.isFocusDescription
    },
    isSubmittable() {
      return this.isNotEmptyNickname && this.isNotEmptyScreenName
    },
    hasFileError() {
      return this.fileErrorMessage.length !== 0
    },
    isDisabledBirthdayDisplayable() {
      return !this.isBirthdayDisplayable
    }
  },
  methods: {
    onNicknameFocus() {
      this.isFocusNickname = true
    },
    onNicknameBlur() {
      this.isFocusNickname = false
    },
    onScreenNameFocus() {
      this.isFocusScreenName = true
    },
    onScreenNameBlur() {
      this.isFocusScreenName = false
    },
    onDescriptionFocus() {
      this.isFocusDescription = true
    },
    onDescriptionBlur() {
      this.isFocusDescription = false
    },
    enterError() {
      setTimeout(() => {
        this.hasErrors = false
      }, 3000)
    },
    onFileChange(e) {
      this.fileErrorMessage = ''
      const files = e.target.files || e.dataTransfer.files
      if (
        this.validationFileSize(files[0].size) &&
        this.validationFileType(files[0].type)
      ) {
        this.isUploaded = true
        this.createImage(files[0])
      }
    },
    createImage(file) {
      const reader = new FileReader()
      reader.onload = e => {
        this.uploadedImage = e.target.result
      }
      reader.readAsDataURL(file)
    },
    validationFileSize(fileSize) {
      if (fileSize > 20 * 1024 * 1024) {
        this.isUploaded = false
        this.fileErrorMessage = 'ファイルサイズは20MB以下にしてください'
        const uploadedFile = document.querySelector('#file_upload')
        uploadedFile.value = ''
        return false
      }
      return true
    },
    validationFileType(fileType) {
      const allowedExtensions = [
        'image/jpg',
        'image/jpeg',
        'image/png',
        'image/gif'
      ]
      if (!allowedExtensions.includes(fileType)) {
        this.isUploaded = false
        this.fileErrorMessage = 'ファイル形式はJPG、PNG、GIFのみ可能です'
        return false
      }
      return true
    },
    onBirthdayDisplayableCheck() {
      this.isBirthdayDisplayable = !this.isBirthdayDisplayable
    }
  }
}
